import { render, staticRenderFns } from "./zb.vue?vue&type=template&id=298932a8&scoped=true&"
import script from "./zb.vue?vue&type=script&lang=js&"
export * from "./zb.vue?vue&type=script&lang=js&"
import style0 from "./zb.vue?vue&type=style&index=0&id=298932a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298932a8",
  null
  
)

export default component.exports